/**
 * 合作方设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PartnerManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region partner 合作方设置接口
  /**
   * 添加合作方
   * @param param
   * @returns {Observable<any>}
   */
  savePartner(param) {
    const url = this.prefix + 'partner/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改合作方
   * @param param
   * @returns {Observable<any>}
   */
  updatePartner(param) {
    const url = this.prefix + 'partner/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 删除合作方信息
   * @param param 
   */
  deletePartner(param) {
    const url = this.prefix + 'partner/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 查看合作方信息
   * @param param
   * @returns {Observable<any>}
   */
  queryPartnerById(param) {
    const url = this.prefix + 'partner/queryById';
    return this.http.Post(url, param);
  }

    /**
   * 清除缓存
   * @param param
   * @returns {Observable<any>}
   */
  deleteCache(param) {
    const url = this.prefix + 'partner/deleteCache?'+param;
    return this.http.Get(url);
  }
  //#endregion


}
